module.exports = __webpack_public_path__ + "static/quote@2x-d05e03d36cacaa83cadf86b56d248a4f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/hudl/quote@2x.jpg
// module id = 382
// module chunks = 3627797113349 20562973939449 33019919093843